import { render, staticRenderFns } from "./OrcamentoDialog.vue?vue&type=template&id=7c115d05&scoped=true&"
import script from "./OrcamentoDialog.vue?vue&type=script&lang=js&"
export * from "./OrcamentoDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c115d05",
  null
  
)

export default component.exports